import React, { forwardRef, useEffect, useRef } from "react";
import BarcodeLabel from "./BarcodeLabel";
import QrCodeLabel from "./QrCodeLabel";

// RollLabelPreview Component
const RollLabelPreview = forwardRef(
  ({ labelWidth, labelHeight, gap, padding, labels, bcid }, ref) => {

    // DEBUG: log actual rendered dimensions vs expected
    useEffect(() => {
      if (!ref?.current) return;
      const container = ref.current;
      const firstLabel = container.querySelector(".label");
      const containerRect = container.getBoundingClientRect();
      const labelRect = firstLabel?.getBoundingClientRect();
      const PX_PER_MM = 96 / 25.4; // browser standard

      console.group("🔍 RollLabelPreview — Layout Debug");
      console.log("Expected labelWidth (mm):", labelWidth, "→ px:", Math.round(labelWidth * PX_PER_MM));
      console.log("Expected labelHeight (mm):", labelHeight, "→ px:", Math.round(labelHeight * PX_PER_MM));
      console.log("Container actual px:", { w: containerRect.width, h: containerRect.height });
      console.log("Container actual mm:", {
        w: (containerRect.width / PX_PER_MM).toFixed(2),
        h: (containerRect.height / PX_PER_MM).toFixed(2),
      });
      if (labelRect) {
        console.log("First .label actual px:", { w: labelRect.width, h: labelRect.height });
        console.log("First .label actual mm:", {
          w: (labelRect.width / PX_PER_MM).toFixed(2),
          h: (labelRect.height / PX_PER_MM).toFixed(2),
        });
        console.log("Right gap (px):", containerRect.width - labelRect.width);
        console.log("Right gap (mm):", ((containerRect.width - labelRect.width) / PX_PER_MM).toFixed(2));
      }
      console.groupEnd();
    }, [labels, labelWidth, labelHeight, ref]);

    return (
      <div ref={ref} className="roll-container">
        {labels.map((lbl, idx) => (
          bcid === 'qrcode' ? (
            <QrCodeLabel
              key={idx}
              condition={lbl?.condition}
              category={lbl?.category}
              itemName={lbl.itemName}
              itemPrice={lbl.sellingPrice}
              value={lbl.barcode}
              backgroundColor="#fffc"
              labelWidth={labelWidth}
              labelHeight={labelHeight}
              showPrice={lbl.showPrice}
              showBatteryHealth={lbl.showBatteryHealth}
              deviceMode={lbl.deviceMode}
            />
          ) : (
            <BarcodeLabel
              key={idx}
                        
            batteryHealth={lbl?.batteryHealth}

              condition={lbl?.condition}
              category={lbl?.category}
              itemName={lbl.itemName}
              itemPrice={lbl.sellingPrice}
              companyName={"JJSOFT GLOBAL"}
              value={lbl.barcode}
              backgroundColor="#fffc"
              labelWidth={labelWidth}
              labelHeight={labelHeight}
              showPrice={lbl.showPrice}
              showBatteryHealth={lbl.showBatteryHealth}
              deviceMode={lbl.deviceMode}
            />
          )
        ))}
      </div>
    );
  }
);

export default RollLabelPreview;
